// extracted by mini-css-extract-plugin
export default {"prepositionForm":"cVSuJ__prepositionForm"};